// Generated by ReScript, PLEASE EDIT WITH CARE

import * as GraphqlTag from "graphql-tag";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as UserContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/UserContext.res.mjs";
import * as MutationHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/MutationHook2.res.mjs";

var Raw = {};

var query = GraphqlTag.gql(["mutation giveHighFive($userId: String!, $otherUserId: String!, $reason: String!)  {\ngiveHighFive(userId: $userId, otherUserId: $otherUserId, reason: $reason)  \n}\n"]);

function parse(value) {
  return {
          giveHighFive: value.giveHighFive
        };
}

function serialize(value) {
  var value$1 = value.giveHighFive;
  return {
          giveHighFive: value$1
        };
}

function serializeVariables(inp) {
  return {
          userId: inp.userId,
          otherUserId: inp.otherUserId,
          reason: inp.reason
        };
}

function makeVariables(userId, otherUserId, reason, param) {
  return {
          userId: userId,
          otherUserId: otherUserId,
          reason: reason
        };
}

var HighFive_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Mutation.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useWithState = include.useWithState;

var HighFive = {
  HighFive_inner: HighFive_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useWithState: useWithState
};

var HF = MutationHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useWithState: useWithState
    });

function useHighFive() {
  var user = UserContext$LiteracyplanetClientFlags.use();
  var userId = user.userId;
  var request = HF.useAsync("HighFive");
  return async function (otherUserId, reason) {
    var match = await request({
          userId: userId,
          otherUserId: otherUserId,
          reason: reason
        });
    var match$1 = match.data;
    if (match$1 !== undefined) {
      return match$1.giveHighFive;
    } else {
      return false;
    }
  };
}

var Raw$1 = {};

var query$1 = GraphqlTag.gql(["mutation giveThumbsUp($userId: String!, $otherUserId: String!)  {\ngiveThumbsUp(userId: $userId, otherUserId: $otherUserId)  \n}\n"]);

function parse$1(value) {
  return {
          giveThumbsUp: value.giveThumbsUp
        };
}

function serialize$1(value) {
  var value$1 = value.giveThumbsUp;
  return {
          giveThumbsUp: value$1
        };
}

function serializeVariables$1(inp) {
  return {
          userId: inp.userId,
          otherUserId: inp.otherUserId
        };
}

function makeVariables$1(userId, otherUserId, param) {
  return {
          userId: userId,
          otherUserId: otherUserId
        };
}

var ThumbsUp_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1
};

var include$1 = SpaceX$LiteracyplanetClientFlags.Mutation.Extend({
      query: query$1,
      Raw: Raw$1,
      parse: parse$1,
      serialize: serialize$1,
      serializeVariables: serializeVariables$1
    });

var use$1 = include$1.use;

var useWithState$1 = include$1.useWithState;

var ThumbsUp = {
  ThumbsUp_inner: ThumbsUp_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  use: use$1,
  useWithState: useWithState$1
};

var TU = MutationHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw$1,
      use: use$1,
      useWithState: useWithState$1
    });

function useThummbsUp() {
  var user = UserContext$LiteracyplanetClientFlags.use();
  var userId = user.userId;
  var request = TU.useAsync("ThumbsUp");
  return async function (otherUserId) {
    var match = await request({
          userId: userId,
          otherUserId: otherUserId
        });
    var match$1 = match.data;
    if (match$1 !== undefined) {
      return match$1.giveThumbsUp;
    } else {
      return false;
    }
  };
}

export {
  HighFive ,
  HF ,
  useHighFive ,
  ThumbsUp ,
  TU ,
  useThummbsUp ,
}
/* query Not a pure module */
